import api from './ApiService';

export async function getDashboardResume() {
  const { data } = await api.get('dashboard-resume');
  return data;
}
